"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFieldGroupWidget = void 0;
var tslib_1 = require("tslib");
var TableauUI = tslib_1.__importStar(require("@tableau/tableau-ui"));
var React = tslib_1.__importStar(require("react"));
var Declarative_1 = require("../../utils/Declarative");
var MenuButtonWidget_1 = require("../Button/MenuButtonWidget");
/**
 * A component which visually groups a `TextFieldWidget` with a `ButtonWidget` and/or a `MenuButtonWidget`.
 *
 * All props not defined in `TextFieldGroupProps` will be rested to the root element.
 */
var TextFieldGroupWidget = function (_a) {
    var button = _a.button, menuButton = _a.menuButton, testId = _a.testId, textField = _a.textField, htmlAttrs = tslib_1.__rest(_a, ["button", "menuButton", "testId", "textField"]);
    if (menuButton) {
        MenuButtonWidget_1.validateMenuButtonProps(menuButton.props);
    }
    return React.createElement(TableauUI.TextFieldGroup, tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testId, exports.TextFieldGroupWidget.displayName) }, htmlAttrs, { textField: textField, button: button, children: menuButton }));
};
exports.TextFieldGroupWidget = TextFieldGroupWidget;
exports.TextFieldGroupWidget.displayName = 'TextFieldGroupWidget';
//# sourceMappingURL=TextFieldGroupWidget.js.map